package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

/** The full product catalog of a location: its category tree and its products. */
@Serializable
data class GetLocationProductsResponseModel(
    val merchantLocationId: Long = 0L,
    val categories: List<ProductCategoryModel> = emptyList(),
    val products: List<ProductModel> = emptyList()
) : BaseResponseModel()

/** Generic response for catalog mutations that returns the affected id. */
@Serializable
data class SaveCatalogItemResponseModel(
    val id: Long? = null
) : BaseResponseModel()
